const career = {
  hero: {
    title: 'Твоя карʼєра тут',
    paragraphs: [
      'Pegasus arms — це українська miltech-компанія замкнутого циклу, яка постачає для Сил оборони України ударні БПЛА',
      'Заповнюй форму та ставай частиною команди, яка працює на Перемогу!',
    ],
    adventages: {
      title: 'Наші переваги:',
      items: [
        'Офіційне працевлаштування',
        'Бронювання співробітників',
        'Гідна заробітна плата',
        'Комфортні умови праці',
        'Навчання та підтримка',
        'Відпустка 24 календарних дні',
        'Оплата лікарняних',
      ],
    },
  },
  lookingFor: {
    title: 'Ми шукаємо',
    paragraphs: [
      'фахівців у команду, які створюють, обслуговують і вдосконалюють ударні БпЛА Pegasus Arms. Обери напрям, який ближчий саме тобі.',
      'Детальні описи вакансій та умови роботи доступні на наших сторінках у партнерських сервісах з працевлаштування — знайди напрям, який підходить саме тобі.',
    ],
    cards: [
      {
        title: 'Інженерія та розробка',
        description:
          'Інженер, Електротехнік, Програмувальник, Тестувальник, Розробник',
        count: '11 вакансій',
        icon: 'engineering',
      },
      {
        title: 'Виробництво',
        description: 'Монтажник, Технік, Механік, Випробувач',
        count: '5 вакансій',
        icon: 'production',
      },
      {
        title: 'Сервіс',
        description:
          'Сервісний спеціаліст, Оператор, Пілот, Інструктор, Технік з обслуговування',
        count: '4 вакансій',
        icon: 'service',
      },
      {
        title: 'Управління',
        description:
          'Менеджер, Бухгалтер, Фінансист, Економіст, Юрист, HR, Методист, Асистент',
        count: '10 вакансій',
        icon: 'management',
      },
    ],
  },
  questions: {
    title: 'Маєш питання щодо вакансій?',
    contacts: {
      email: {
        text: 'Пиши в наш HR-відділ:',
        link: 'hr@pegasusarms.com.ua',
      },
      tel: {
        text: 'або телефонуй:',
        link: '+380 (75) 444 55 83',
      },
    },
  },
  form: {
    title: '/ ПОДАТИСЯ НА ВАКАНСІЮ',
    inputs: {
      vacancy: {
        label: 'Вакансія',
        placeholder: 'Виберіть вакансію',
      },
      message: {
        label: 'Коментар',
        placeholder: 'Розкажіть нам про ваш досвід',
      },
      summary: {
        label: 'Резюме',
        placeholder: 'Завантажити файл',
        placeholder2: '(PDF або DOCX, до  10 MB)'
      }
    },
    button: 'Подати заявку',
    jobs: {
      pilotTester: 'Пілот-тестувальник',
      pilotInstructor: 'Пілот-інструктор',
      arduplaneEngineer: 'ArduPlane Engineer',
      embeddedArdu: 'Embedded-інженер з ArduCopter',
      uavRepair: 'Інженери з ремонту БПЛА',
      financeManager: 'Фінансовий менеджер (кредитування/гранти)',
      assembler: 'Збиральники БПЛА',
      soldering: 'Пайщики',
    },
    validations: {
      vacancy: {
        valueMissing: 'Оберіть вакансію',
      },
      message: {
        valueMissing: 'Введіть ваше повідомлення',
        typeMismatch: 'Введіть коректне повідомлення',
      },
      summary: {
        valueMissing: 'Завантажте файл',
        sizeExceeded: 'Розмір файлу не повинен перевищувати 10 MB'
      },
    },
  }
}
export default career
